// src/contexts/SoundContext.jsx
import React, { createContext, useState, useEffect } from "react";

export const SoundContext = createContext();

export const SoundProvider = ({ children }) => {
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    const storedMuteSetting = localStorage.getItem("soundMuted");
    if (storedMuteSetting !== null) {
      setIsMuted(storedMuteSetting === "true");
    }
  }, []);

  const toggleMute = () => {
    const newMuteSetting = !isMuted;
    setIsMuted(newMuteSetting);
    localStorage.setItem("soundMuted", newMuteSetting.toString());
  };

  return (
    <SoundContext.Provider value={{ isMuted, toggleMute }}>
      {children}
    </SoundContext.Provider>
  );
};
